import { RelationPairs } from '@backstage/plugin-catalog-graph';

export const RELATION_SCAFFOLDED_BY = 'scaffoldedBy';
export const RELATION_SCAFFOLDER_OF = 'scaffolderOf';
export const RELATION_HAS_VICE_PRESIDENTS = 'hasVicePresident';
export const RELATION_VICE_PRESIDENT_OF = 'vicePresidentOf';
export const RELATION_HAS_ENGINEER_MANAGERS = 'hasEngineerManager';
export const RELATION_ENGINEER_MANAGER_OF = 'engineerManagerOf';
export const RELATION_HAS_DIRECTORS = 'hasDirector';
export const RELATION_DIRECTOR_OF = 'directorOf';
export const RELATION_HAS_PRINCIPAL_ENGINEERS = 'hasPrincipalEngineer';
export const RELATION_PRINCIPAL_ENGINEER_OF = 'principalEngineerOf';
export const RELATION_HAS_TECH_LEADS = 'hasTechLead';
export const RELATION_TECH_LEAD_OF = 'techLeadOf';

export const CUSTOM_RELATION_PAIRS: RelationPairs = [[RELATION_SCAFFOLDED_BY, RELATION_SCAFFOLDER_OF]];
